import exchangeApp from './reducers';

export default exchangeApp;
